var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.msg)?_c('div',{staticClass:"error-message-container"},[_c('div',{staticClass:"error-message"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.msg)}}),_c('div',{staticClass:"guide-error"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }